import ImageCarousel from "./ImageCarousel";

export default ImageCarousel;
